import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';

import yogurt from '../../../../assets/images/yogurtMeal.webp';
import toast from '../../../../assets/images/toastMeal.webp';
import tortilla from '../../../../assets/images/tortillaMeal.webp';
import pizza from '../../../../assets/images/pizzaMeal.png';

const MealPlanContainerPizza = () => {

  return (
    <div className={styles.mealPlanContainer}>
      <div className={styles.mealPlan}>
        {[
          {
            dishName: t('onboarding.mealPlanContainer.yogurtMeal.title'),
            image: yogurt,
            mealType: t('onboarding.mealPlanContainer.yogurtMeal.breakfast'),
          },
          {
            dishName: t('onboarding.mealPlanContainer.pizza'),
            image: pizza,
            mealType: t('onboarding.mealPlanContainer.beefMeal.lunch'),
          },
          {
            dishName: t('onboarding.mealPlanContainer.toastMeal.title'),
            image: toast,
            mealType: t('onboarding.mealPlanContainer.toastMeal.snack'),
          },
          {
            dishName: t('onboarding.mealPlanContainer.tortillaMeal.title'),
            image: tortilla,
            mealType: t('onboarding.mealPlanContainer.tortillaMeal.dinner'),
          },
        ].map((item, idx) => (
          <div className={styles.card} key={idx}>
            <div className={styles.cardImage}>
              <img className={styles.image} src={item.image} alt='img' />
            </div>

            <Text size='m' bold className={styles.cardHeader}>
              {item.dishName}
            </Text>
            <div className={styles.mealDetails}>
              <Text size='s' semibold className={styles.mealType}>
                {item.mealType}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MealPlanContainerPizza;
